import { FORGET_PASSWORD } from "./actionTypes";

export const passwordReset = (url) => {
  return {
    type: FORGET_PASSWORD,
    payload: url,
  };
};
